import React from "react";
import CommentItem from "./CommentItem";
import styles from "./CommentList.modules.less";

export interface IProps {
  commentData: any[];
  title?: string;
  response?: () => void;
}

class CommentList extends React.Component<IProps> {
  public render() {
    const { commentData, title = "最新評論", response } = this.props;

    return (
      <section className={styles["CommentList"]}>
        <h3 className={styles["title"]}>{title}</h3>
        {commentData.length !== 0 &&
          commentData.map((vv: any) =>
            vv.map((v: any, i: number) => <CommentItem key={i} data={v} response={response} />),
          )}
      </section>
    );
  }
}

export default CommentList;
